export const parseRouteId = (value?: string | null): number | undefined => {
    if (!value || value.toLowerCase() === "create") {
        return undefined;
    }

    const id = Number(value);
    return Number.isInteger(id) && id > 0 ? id : undefined;
};
